import { createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import {
  addNewUser,
  addUserFile,
  AddUsersApi,
  AssignUserApi,
  CheckUserApi,
  deleteuserApi,
  getAllLoginHistory,
  getAllUsers,
  getAllUsersWithoutProfiles,
  getjobpostionsOptions,
  userDataUpdate,
  userGetByid,
  userStatus,
} from "../../Api/services/user-Management";

const userManagementSlice = createSlice({
  name: "usersManagement",
  initialState: {
    usersManagementData: [],
    userProfiles: [],
    userSingleData: [],
    joboptionsData: [],
    loginHistory: [],
    error: null,
    loading: false,
    loaginHistoryLoading: false,
    singleDataLoading: false,
    usersWithoutProfiles: [],
  },
  extraReducers: (builder) => {
    //get user list
    builder
      .addCase(getAllUsers.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          usersManagementData: action.payload.data,
          loading: false,
        };
      })
      .addCase(getAllUsers.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //get user by id
    builder
      .addCase(userGetByid.pending, (state) => {
        return {
          ...state,
          singleDataLoading: true,
        };
      })
      .addCase(userGetByid.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          userSingleData: action.payload,
          singleDataLoading: false,
        };
      })
      .addCase(userGetByid.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          singleDataLoading: false,
          error: action.payload,
        };
      });
    //get job postion options data
    builder
      .addCase(getjobpostionsOptions.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getjobpostionsOptions.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          joboptionsData: action.payload,
          loading: false,
        };
      })
      .addCase(getjobpostionsOptions.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //get login history
    builder
      .addCase(getAllLoginHistory.pending, (state) => {
        return {
          ...state,
          loaginHistoryLoading: true,
        };
      })
      .addCase(getAllLoginHistory.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          loginHistory: action.payload,
          loaginHistoryLoading: false,
        };
      })
      .addCase(getAllLoginHistory.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loaginHistoryLoading: false,
          error: action.payload,
        };
      });

    //add new user
    builder
      .addCase(AddUsersApi.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(AddUsersApi.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(AddUsersApi.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //check existing user
    builder
      .addCase(CheckUserApi.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(CheckUserApi.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(CheckUserApi.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //assign existing user
    builder
      .addCase(AssignUserApi.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(AssignUserApi.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(AssignUserApi.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //delete user
    builder
      .addCase(deleteuserApi.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(deleteuserApi.fulfilled, (state, action) => {
        if (action?.payload?.success === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(deleteuserApi.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //user status
    builder
      .addCase(userStatus.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(userStatus.fulfilled, (state, action) => {
        if (action?.payload?.success === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(userStatus.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //user update data
    builder
      .addCase(userDataUpdate.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(userDataUpdate.fulfilled, (state, action) => {
        if (action?.payload?.success === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(userDataUpdate.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    // add user import
    builder
      .addCase(addUserFile.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(addUserFile.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(addUserFile.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //get user without profiles list
    builder
      .addCase(getAllUsersWithoutProfiles.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getAllUsersWithoutProfiles.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          usersWithoutProfiles: action.payload,
          loading: false,
        };
      })
      .addCase(getAllUsersWithoutProfiles.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //add new user, check if old one should be deleted
    builder
      .addCase(addNewUser.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(addNewUser.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(addNewUser.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
  },
});

export default userManagementSlice.reducer;
